enum PlanDetectionProvider {
    Wisebim = "Wisebim",
    Amplify = "Amplify"
}

export default PlanDetectionProvider;
